import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useClient } from '../../ViewClient/hooks';

export const ClientRulesBreadcrumb = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const { client } = useClient(clientId ? parseInt(clientId, 10) : 0);

  const breadcrumbs = useMemo(
    () => [
      { label: 'Clientes', path: '/clients' },
      { label: client?.name || 'cliente', path: `/clients/${clientId}` },
      { label: 'Reglas' },
    ],
    [client?.name, clientId],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
